import { useEffect, useCallback } from "react";
import { generatePath, Params, useMatch, useNavigate } from "react-router";
import { Company } from "@vviinn/user-managment-client-ts";
import { useApi } from "../../api";
import {
  useAppDispatch,
  useAppSelector,
  fetchSuccinctSites,
} from "../../store";

export const useCompanySelect = () => {
  const { getApi } = useApi();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const isCompanyState = useMatch("/company/:companyId/*");
  const isCompanyContractState = useMatch("/company/:companyId/contract/*");

  const isUserAuthed = useAppSelector((state) => state.user.isAuth);
  const companies = useAppSelector((state) => state.companies.companies);
  const selectedCompanyId = useAppSelector(
    (state) => state.company.company?.id,
  );

  const redirectCompany = useCallback(
    (id: Company["id"]) => {
      if (!isCompanyState && !isCompanyContractState) return;

      if (isCompanyContractState) {
        navigate(`/company/${id}/`, { replace: true });
      } else if (isCompanyState) {
        const { params, pattern } = isCompanyState;
        const newParams = {
          ...params,
          companyId: `${id}`,
        } as Params<string>;
        const newPath = generatePath(pattern.path, newParams);
        navigate(newPath, { replace: true });
      }
    },
    [isCompanyState, isCompanyContractState, navigate, selectedCompanyId],
  );

  const updateSites = useCallback(
    async (id: Company["id"]) => {
      const api = await getApi();
      await dispatch(fetchSuccinctSites({ api, value: id }));
    },
    [dispatch, getApi],
  );

  useEffect(() => {
    if (!selectedCompanyId || !companies || !isUserAuthed) return;
    redirectCompany(selectedCompanyId);
    updateSites(selectedCompanyId);
  }, [selectedCompanyId, companies]);
};
